import React from 'react';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-400 py-12 border-t border-gray-800" data-id="element-77">
      <div className="container mx-auto px-4" data-id="element-78">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8" data-id="element-79">
          <div className="text-2xl font-black text-white font-montserrat tracking-tighter" data-id="element-80">
            FIT<span className="text-vibrantGreen" data-id="element-81">RECETAS</span>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-medium" data-id="element-82">
            <span className="flex items-center gap-2" data-id="element-83">
              <span className="w-1.5 h-1.5 rounded-full bg-vibrantGreen" data-id="element-84"></span>
              Producto 100% digital
            </span>
            <span className="flex items-center gap-2" data-id="element-85">
              <span className="w-1.5 h-1.5 rounded-full bg-vibrantGreen" data-id="element-86"></span>
              Acceso inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-87">
              <span className="w-1.5 h-1.5 rounded-full bg-vibrantGreen" data-id="element-88"></span>
              No se envía producto físico
            </span>
          </div>
        </div>

        <div className="text-center text-xs text-gray-600 border-t border-gray-800 pt-8" data-id="element-89">
          <p className="mb-2" data-id="element-90">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <p data-id="element-91">
            &copy; {new Date().getFullYear()} FitRecetas. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}